import type { FC } from 'react';
import { Card, Spinner, Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { SurLaTableMiniIcon } from '../icons';

interface Props {
    isLoading: boolean;
}

export const LoadingIndicator: FC<Props> = ({ isLoading }) =>
    isLoading ? (
        <div
            data-testid="loading-indicator"
            className="fixed inset-0 z-[999] flex items-center justify-center bg-black/60"
        >
            <Card w="464px" h="258px">
                <div className="flex h-full w-full flex-col items-center justify-center space-y-2">
                    <div className="relative">
                        <div className="absolute flex h-full w-full flex-col items-center justify-center">
                            <SurLaTableMiniIcon w="1.5rem" h="1.5rem" />
                        </div>
                        <Spinner speed="0.65s" thickness="3px" color="#666666" size="xl" />
                    </div>
                    <Text className="mt-2" textStyle="slt-body-text-lg" fontWeight={450}>
                        <FormattedMessage
                            id="loading-indicator-text"
                            defaultMessage="Please give us a second..."
                        />
                    </Text>
                </div>
            </Card>
        </div>
    ) : null;
